export enum AuthEndpointsEnum {
  WEB_KEY = "/web/key",
  COOKIE_SESSION = "/web/cookie",
  PROFILE = "/user/profile/:id",
  RELATIONSHIP = "/relationship/user",
  OTP = "/user/otp/v2",
  LIBRARY_ID = "/content/me/personal-library-id",
  LOGOUT = "/web/logout",
}
